module.exports = __webpack_public_path__ + "static/media/TrelloDev.ccd6424d.png";